import React, { useEffect } from 'react';
import getConfig from 'next/config';
import { Box, Typography } from '@mui/material';
import { AmplitudeLogger } from '@/utilities/analyticsHelper';
import { EventNames, TEXTS } from '@/constants';
import useDirectEnrollmentData from '@/components/hooks/useDirectEnrollmentData';

const {
  ONE_CLICK_ENROLLMENT: { WELCOME_LANDING_PAGE_STEP_NAME },
} = TEXTS;

interface LandingProps {
  logger: AmplitudeLogger;
}

const {
  publicRuntimeConfig: { NEXT_PUBLIC_CDN_ROOT },
} = getConfig();

const Landing: React.FC<LandingProps> = ({ logger }: LandingProps) => {
  const { fetch } = useDirectEnrollmentData();
  const { firstName } = fetch();
  useEffect(() => {
    logger({
      name: EventNames.SCREEN_VIEWED,
      data: {
        step_name: WELCOME_LANDING_PAGE_STEP_NAME,
      },
    });
  }, []);

  return (
    <>
      <Typography variant="h1" color="textPrimary">
        Hi, {firstName}!
      </Typography>
      <Typography variant="body1" color="textPrimary">
        Create your free, employer-sponsored account today
      </Typography>
      <Box
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 1.5,
        }}>
        <Box
          component="img"
          src={`${NEXT_PUBLIC_CDN_ROOT}/img/cms/web/careAtWork/directEnrollment/Babysitters.svg`}
          sx={{
            height: '75px',
            width: '75px',
            verticalAlign: 'middle',
          }}
          alt="Babysitters"
        />
        <Typography variant="subtitle1" color="textPrimary">
          Get trusted backup care when you need it most
        </Typography>
      </Box>
      <Box
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 1.5,
        }}>
        <Box
          component="img"
          src={`${NEXT_PUBLIC_CDN_ROOT}/img/cms/web/careAtWork/directEnrollment/Shield%20Check.svg`}
          sx={{
            height: '75px',
            width: '75px',
            verticalAlign: 'middle',
          }}
          alt="Shield"
        />
        <Typography variant="subtitle1" color="textPrimary">
          Book a local, background-checked sitter
        </Typography>
      </Box>
      <Box
        component="div"
        sx={{
          display: 'flex',
          alignItems: 'center',
          mt: 1.5,
        }}>
        <Box
          component="img"
          src={`${NEXT_PUBLIC_CDN_ROOT}/img/cms/web/careAtWork/directEnrollment/Chat-Bubbles.svg`}
          sx={{
            height: '75px',
            width: '75px',
            verticalAlign: 'middle',
          }}
          alt="ChatBubbles"
        />
        <Typography variant="subtitle1" color="textPrimary">
          Chat with caregivers to find the right fit faster
        </Typography>
      </Box>
    </>
  );
};

export default Landing;
